function path(root, sublink) {
    return `${root}${sublink}`
}

const ROOTS_DASHBOARD = "/dashboard"

export const PATH_AUTH = {
    login: "/login"
}

export const PATH_DELETE_ACCOUNT = {
    delete: "/delete-account"
}

export const PATH_BUS_STATION = {
    station: "/station"
}

export const PATH_DASHBOARD = {
    root: ROOTS_DASHBOARD,
    departure: path(ROOTS_DASHBOARD, "/departure"),
    map: path(ROOTS_DASHBOARD, "/map"),
    mira: path(ROOTS_DASHBOARD, "/mira"),
    stations: {
        root: path(ROOTS_DASHBOARD, "/stations"),
        new: path(ROOTS_DASHBOARD, "/stations/new"),
        edit: (id) => path(ROOTS_DASHBOARD, `/stations/${id}/edit`)
    },
    drivers: {
        root: path(ROOTS_DASHBOARD, "/drivers"),
        new: path(ROOTS_DASHBOARD, "/drivers/new"),
        edit: (id) => path(ROOTS_DASHBOARD, `/drivers/${id}/edit`)
    },
    buses: {
        root: path(ROOTS_DASHBOARD, "/buses"),
        new: path(ROOTS_DASHBOARD, "/buses/new"),
        edit: (id) => path(ROOTS_DASHBOARD, `/buses/${id}/edit`)
    },
    schedule: {
        root: path(ROOTS_DASHBOARD, "/schedule"),
        new: path(ROOTS_DASHBOARD, "/schedule/new"),
        configuration: path(ROOTS_DASHBOARD, "/schedule/configuration"),
    },
    routes: {
        root: path(ROOTS_DASHBOARD, "/routes"),
        new: path(ROOTS_DASHBOARD, "/routes/new"),
        edit: (id) => path(ROOTS_DASHBOARD, `/routes/${id}/edit`)
    },
    reports: {
        root: path(ROOTS_DASHBOARD, "/reports"),
        historical: path(ROOTS_DASHBOARD, "/reports/historical"),
        day: path(ROOTS_DASHBOARD, "/reports/day"),
        bus: path(ROOTS_DASHBOARD, "/reports/bus")
    },
    settings: path(ROOTS_DASHBOARD, "/settings")
}